import {useMutation} from 'react-query';
import {sendContactEmail} from '../../api/contact'

export function useContactUs({queryConfig = {}} = {}) {
   return useMutation(sendContactEmail, queryConfig)
}